import { UPDATE_URL, CLEAN_URL } from '../urlRouting/actions';
import { getGeometries } from '../draw/mapAssets';

var domainUrl = function() {

	return window.location.protocol + '//' + window.location.host;
};

const DefaultState = {
  url: domainUrl()
};

const url = (state = DefaultState, action) => {
  switch (action.type) {
    case UPDATE_URL:
       state.url = domainUrl() + action.data;
       return Object.assign({}, state);
    case CLEAN_URL:
      state.url = domainUrl();
      return Object.assign({}, state);
    default:
      return state;
  }
};

export {url};


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/urlRouting/reducer.js